// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"fe1054a6","4080":"019febe0","4135":"1ce97efa","7503":"d3a06034","8403":"b71a74c0"}[chunkId] + ".chunk.css";
};